import UserModel from './UserModel';
import moment from 'moment';

export default class MessageModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.id = data.id || 0;
    this.message_thread = data.message_thread || 0;

    this.sender = data.sender ? new UserModel(data.sender) : null;
    this.receiver = data.receiver ? new UserModel(data.receiver) : null;

    this.heading = data.heading || '';
    this.message = data.message || '';

    this.read = data.read || false;
    this.seen = data.seen || false;

    this.timestamp = moment(data.timestamp).toDate();
    this.extra = data.extra || {};
  }

  // extras
  get notification_type() {
    return this.extra.notification_type || '';
  }

  get appointment_request_id() {
    return this.extra.appointment_request_id || '';
  }

  get appointment_id() {
    return this.extra.appointment_id || '';
  }

  get group_session_id() {
    return this.extra.group_session_id || '';
  }

  get payment_id() {
    return this.extra.payment_id || '';
  }

  get counselor_user_id() {
    return this.extra.counselor_user_id || null;
  }




  get systemMessage() {
    return !this.sender;
  }

  get senderDisplay() {
    if (this.systemMessage) {
      return 'BetterMynd Support Team';
    }
    return this.sender.displayName;
  }

  otherUserName(myUserId) {
    if (this.systemMessage) {
      return 'BetterMynd Support Team';
    }

    if (myUserId === this.sender.id && this.receiver) {
      return this.receiver.displayName
    } else {
      return this.sender.displayName;
    }
  }

  get avatarFileUrl() {
    if (this.sender && this.sender.photo) {
      return this.sender.photo.url;
    }
    return '';
  }

  get canReply() {
    return this.sender && this.receiver;
  }


  getOtherUser(userId) {
    if (this.sender && this.sender.id === userId) {
      return this.receiver.id;
    }

    if (this.receiver && this.receiver.id === userId) {
      return this.sender.id;
    }

    return null;
  }
}
